import React, { lazy } from 'react';

const CNtoSupplierPreviewDetailPDF = lazy(() =>
  import(
    '../../SupplierAccountModule/SupplierAccountPDF/CNtoSupplierPreviewDetailPDF'
  ).then(module => ({
    default: module.CNtoSupplierPreviewDetailPDF,
  })),
);

const DNtoSupplierPreviewDetailPDF = lazy(() =>
  import(
    '../../SupplierAccountModule/SupplierAccountPDF/DNtoSupplierPreviewDetailPDF'
  ).then(module => ({
    default: module.DNtoSupplierPreviewDetailPDF,
  })),
);

const InvoiceToSupplierPreviewDetailPDF = lazy(() =>
  import(
    '../../SupplierAccountModule/SupplierAccountPDF/InvoicetoSupplierPreviewDetailPDF'
  ).then(module => ({
    default: module.InvoiceToSupplierPreviewDetailPDF,
  })),
);

const PaymentsPreviewDetailPDF = lazy(() =>
  import(
    '../../SupplierAccountModule/SupplierAccountPDF/PaymentsPreviewDetailPDF'
  ).then(module => ({
    default: module.PaymentsPreviewDetailPDF,
  })),
);

const SupplierPreviewDetailPDF = lazy(() =>
  import(
    '../../SupplierAccountModule/SupplierAccountPDF/SupplierPreviewDetailPDF'
  ).then(module => ({
    default: module.SupplierPreviewDetailPDF,
  })),
);

const SubconRetentionClaimPreview = lazy(() =>
  import(
    '../../SubconAccountModule/SubconAccountPDF/SubconPreviewDetailPDF/SubconRetentionClaimPreviewDetailPDF'
  ).then(module => ({
    default: module.SubconRetentionClaimPreviewDetailPDF,
  })),
);

const supplierELetterRoutes = [
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/cn-to-supplier/:transactionID/preview',
    },
    component: (
      <CNtoSupplierPreviewDetailPDF
        transactionType="CN to Supplier"
        accountType="supplier"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/dn-to-supplier/:transactionID/preview',
    },
    component: (
      <DNtoSupplierPreviewDetailPDF
        transactionType="DN to Supplier"
        accountType="supplier"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/invoices-to-supplier/:transactionID/preview',
    },
    component: (
      <InvoiceToSupplierPreviewDetailPDF
        transactionType="Invoices to Supplier"
        accountType="supplier"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/supplier-payment/:transactionID/preview',
    },
    component: (
      <PaymentsPreviewDetailPDF
        transactionType="Payments"
        accountType="supplier"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/supplier-payment/:transactionID/preview',
    },
    component: (
      <PaymentsPreviewDetailPDF
        transactionType="Payments"
        accountType="supplier"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/supplier-payment/:transactionID/preview',
    },
    component: (
      <PaymentsPreviewDetailPDF
        transactionType="Payments"
        accountType="supplier"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/supplier-payment/:transactionID/preview',
    },
    component: (
      <PaymentsPreviewDetailPDF
        transactionType="Payments"
        accountType="supplier"
      />
    ),
  },
  ////////////////////ELETTER PREVIEW PDF///////////////
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/cn-to-supplier/:transactionID/e-letter',
    },
    component: (
      <SupplierPreviewDetailPDF
        docType="credit-note"
        accountType="supplier-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/cn-to-supplier/:transactionID/e-letter',
    },
    component: (
      <SupplierPreviewDetailPDF docType="credit-note" accountType="supplier" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/dn-to-supplier/:transactionID/e-letter',
    },
    component: (
      <SupplierPreviewDetailPDF
        docType="debit-note"
        accountType="supplier-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/dn-to-supplier/:transactionID/e-letter',
    },
    component: (
      <SupplierPreviewDetailPDF docType="debit-note" accountType="supplier" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/:ID/invoices-to-supplier/:transactionID/e-letter',
    },
    component: (
      <SupplierPreviewDetailPDF
        docType="invoice"
        accountType="supplier-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/invoices-to-supplier/:transactionID/e-letter',
    },
    component: (
      <SupplierPreviewDetailPDF docType="invoice" accountType="supplier" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/:ID/supplier-payment/:transactionID/e-letter',
    },
    component: (
      <SupplierPreviewDetailPDF
        docType="payment"
        accountType="supplier-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/supplier-payment/:transactionID/e-letter',
    },
    component: (
      <SupplierPreviewDetailPDF docType="payment" accountType="supplier" />
    ),
  },
];

export default supplierELetterRoutes;
